import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";
import DoughnutChart from "components/DoughnutChart";

import MDTypography from "components/MDTypography";

import { PATH, UPLOAD_PATH } from "../../constant";
import 'dayjs/locale/it';

import * as ajax from "helpers/ajax";
import dayjs from 'dayjs';
import MapContainer from "components/GoogleMap";
import CircularProgress from '@mui/material/CircularProgress';
import { calculateImportoContrattuale,calculateBudgetReal, calculateMarkupReal, toPrice, getWorkedDaysNumber, toEuropeanDate, calculateFinalDate, laborCostCommessa, calculateSAL, materialCostCommessa, daysBetween, toDashDate } from "helpers/functions.js"

const size = 100,
    thickness = 9,
    secColor = '#EBEFF4';
const progressCircle = {
    borderRadius: '50%',
    boxShadow: `inset 0 0 0 ${thickness / 44 * size}px ${secColor}`,
    color: "#42424a"
};


export class CartaContabilita extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            worker: [],
            workerLoaded: false,

            sal: [],
            salLoaded: false,
            displayAlert:false
        };
    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("operai-commesses?populate=operaio&filters[commessa][id]=" + this.state.data.id, this.loadWorker)
        ajax.ajaxGetStrapi("sal-commessas?filters[commessa][id][$eq]=" + this.state.data.id, this.loadSal)
    }

    loadWorker = (response) => {
        this.setState({ worker: response.data, workerLoaded: true });
    }

    loadSal = (response) => {
        this.setState({ sal: response.data, salLoaded: true });
    }


    loadCallback = (response) => {

    }

    convertDate = (date) => {
        if (!date) return null;
        var yyyy = date.getFullYear().toString();
        var mm = (date.getMonth() + 1).toString();
        var dd = date.getDate().toString();

        var mmChars = mm.split('');
        var ddChars = dd.split('');

        return yyyy + '-' + (mmChars[1] ? mm : "0" + mmChars[0]) + '-' + (ddChars[1] ? dd : "0" + ddChars[0]);
    }



    totalDuration = () => {
        let duration = this.state.data.durata;
        let duration2 = this.state.data.proroga;

        if (isNaN(parseInt(duration))) {
            duration = 0;
        }
        if (isNaN(parseInt(duration2))) {
            duration2 = 0;
        }

        return parseInt(duration) + parseInt(duration2);
    }

    getBusinessDatesCount = (startDate, duration, returnType = "endDate") => {
        if (!startDate) {
            return 0
        }

        let count = 0;
        let workedDays = 0;

        const curDate = new Date(startDate);
        const endDate = new Date(startDate)
        endDate.setDate(endDate.getDate() + duration);

        while (curDate <= endDate) {
            const dayOfWeek = curDate.getDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                count++;
                if (new Date() > curDate) {
                    workedDays++;
                }
            } else {
                //festivi
                endDate.setDate(endDate.getDate() + 1);
            }
            curDate.setDate(curDate.getDate() + 1);
        }

        switch (returnType) {
            case "endDate": return endDate;
            case "workingDays": return workedDays;
        }

        return endDate;
    }

    sumOrder = () => {
        let n = 0;
        if (!this.state.data.fc_ordini) { return 0 }
        this.state.data.fc_ordini.map((el) => { n += el.amount_gross })
        n += laborCostCommessa(this.state.worker, null, this.state.data.id);

        return n.toFixed(2)
    }



    orderPercentage = () => {
        if (!this.state.data.costo_ordini) { return 0 }

        let n = ((this.sumOrder() * 100) / (this.state.data.costo_ordini + this.state.data.costo_manodopera)).toFixed(2);
        if (n > 100) { return 100 }
        return n
    }

    checkForAlert = (n) => {

        if(n>=0){return n}
        if (!this.state.displayAlert){
            this.setState({displayAlert:true})
        }
        return 0
    }


    render() {

        if (!this.state.workerLoaded) { return null }
        let totalDuration = this.totalDuration();

        let workedDays = getWorkedDaysNumber(this.state.worker);
        let endDate = calculateFinalDate(this.state.data.data_inizio, this.totalDuration(), (this.state.data.days_type == "Consecutivi" ? false : true))
        if (workedDays > totalDuration) { workedDays = totalDuration; }

        let materialCost = materialCostCommessa(this.state.data)
        let laborCost = laborCostCommessa(this.state.worker, null, null, this.state.data.id)


        let importoContrattuale = calculateImportoContrattuale(this.state.data, false)

        if (importoContrattuale == null) { importoContrattuale = 0 }

        let sal = calculateSAL(this.state.sal) / 100;
        let markupReal = calculateMarkupReal(this.state.data, materialCost, laborCost);

        let budget = (importoContrattuale - (importoContrattuale - (this.state.data.costo_ordini + this.state.data.costo_manodopera)))
        let budgetReale = calculateBudgetReal(this.state.data,markupReal)

        let dataStimata = calculateFinalDate(new Date(), this.totalDuration() - workedDays, (this.state.data.days_type == "Consecutivi" ? false : true))

        let scostamento = calculateFinalDate(toDashDate(endDate), daysBetween(endDate, dataStimata), (this.state.data.days_type == "Consecutivi" ? false : true),true);
        if (!scostamento) { scostamento=0}

        return (
            <Grid container mt={3} justifyContent="center" alignItems="center">
                <Grid item sm={12}>
                    <MDBox sx={{ backgroundColor: "white!important" }} p={3} borderRadius="lg" shadow="lg" >

                        <Grid container mb={3}>
                            <Grid item sm={5} justifyContent={"center"}>
                                <MDTypography variant={"h4"}>{this.state.data.nome}
                                {this.state.displayAlert?<Icon style={{ color: '#E53935', marginLeft:10 }} >warning</Icon>:null}
                                </MDTypography>
                            </Grid>
                            <Grid item sm={3}>
                                <MDTypography variant={"h4"}>Data inizio lavori {toEuropeanDate(this.state.data.data_inizio)}</MDTypography>
                            </Grid>
                            <Grid item sm={4}>
                                <MDTypography variant={"h4"}>Data fine lavori contrattuale {endDate}</MDTypography>
                            </Grid>
                        </Grid>



<Grid container>

<Grid item sm={3} style={{ height: "100px" }}>
                                <DoughnutChart
                                    priceMode={true}
                                            data={{
                                                labels: ["Importo contrattuale - costo ad oggi", "Costo totale ad oggi"],
                                                datasets: [
                                                    {
                                                        label: 'Giorni Lavorati',
                                                        data: [this.checkForAlert(importoContrattuale - (materialCost + laborCost)), materialCost + laborCost],
                                                        backgroundColor: ["#1A73E8", "#EF5350"],
                                                        borderWidth: 0
                                                    }
                                                ]

                                            }}
                                        />

                                    </Grid>

                                    <Grid item sm={4} style={{ height: "100px", borderLeft:"1px solid #ccc",borderRight:"1px solid #ccc" }}>
                                <DoughnutChart
                                    priceMode={true}
                                            data={{
                                                labels: ["Budget reale", "Budget preventivato -reale"],
                                                datasets: [
                                                    {
                                                        label: 'Giorni Lavorati',
                                                        data: [budgetReale, this.checkForAlert(budget - budgetReale) ],
                                                        backgroundColor: ["#1A73E8", "#EF5350"],
                                                        borderWidth: 0
                                                    }
                                                ]

                                            }}
                                        />

                                    </Grid>


                                    <Grid item sm={5} style={{ height: "100px" }}>

                                <DoughnutChart
                                    priceMode={false}
                                            data={{
                                                labels: ["Giorni lavorati", "Giorni mancanti"],
                                                datasets: [
                                                    {
                                                        label: 'Giorni Lavorati',
                                                        data: [workedDays, totalDuration - workedDays],
                                                        backgroundColor: ["#1A73E8", "#EF5350"],
                                                        borderWidth: 0
                                                    }
                                                ]

                                            }}
                                        />
                                    </Grid>

                                    </Grid>

                        <Grid container alignItems="center">
                            <Grid item sm={3} style={{}}>
                                <Grid container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Grid item sm={8}
                                        direction="column"
                                        justifyContent="center"
                                        style={{ height: "100%", display: "flex" }}
                                    >
                                        <Grid container>
                                            <Grid item>
                                                <MDTypography variant={"button"}>Importo contrattuale: <span style={{ marginLeft: 5 }} /></MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}>{toPrice(importoContrattuale)}</MDTypography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item>
                                                <MDTypography variant={"button"}>Costi preventivati: <span style={{ marginLeft: 5 }} /></MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}>{(this.state.data.costo_ordini) ? toPrice(this.state.data.costo_ordini + this.state.data.costo_manodopera) : toPrice(0)}</MDTypography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item>
                                                <MDTypography variant={"button"}>Costo totale ad oggi: <span style={{ marginLeft: 5 }} /></MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}>{toPrice(materialCost + laborCost)}</MDTypography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>



                            {/*mezzo*/}
                            <Grid item sm={4} style={{borderLeft:"1px solid #ccc",borderRight:"1px solid #ccc"}}>
                                <Grid container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Grid item sm={8}
                                        direction="column"
                                        justifyContent="center"
                                        style={{ height: "100%", display: "flex" }}
                                    >
                                        <Grid container>
                                            <Grid item>
                                                <MDTypography variant={"button"}>Budget di commessa preventivato:<span style={{ marginLeft: 5 }} /> </MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}>{" "}{toPrice(budget)}</MDTypography>
                                            </Grid>
                                        </Grid>

                                        <Grid container>
                                            <Grid item>
                                                <MDTypography variant={"button"}>Budget di commessa reale:<span style={{ marginLeft: 5 }} /> </MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}> {toPrice(budgetReale)}</MDTypography>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                            {/*mezzo*/}


                            <Grid item sm={5}>
                                <Grid container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <Grid item sm={6}
                                        direction="column"
                                        justifyContent="center"
                                        style={{ height: "100%", display: "flex", paddingLeft:20 }}
                                    >
                                        <MDTypography variant={"h4"}>
                                            {totalDuration} <MDTypography variant={"button"} >Giorni TOTALI</MDTypography>
                                        </MDTypography>
                                        <MDTypography variant={"h4"}>
                                            {workedDays} <MDTypography variant={"button"} >Giorni LAVORATI</MDTypography>
                                            {"   "}<MDBadge color={"info"} badgeContent={" "} container indicator />
                                        </MDTypography>
                                        <MDTypography variant={"h4"}>
                                            {totalDuration - workedDays} <MDTypography variant={"button"} >Giorni MANCANTI</MDTypography>
                                            {"   "}<MDBadge color={"error"} badgeContent={" "} container indicator />
                                        </MDTypography>
                                    </Grid>
                                    <Grid item sm={6}
                                        direction="column"
                                        justifyContent="center"
                                        style={{ height: "100%", display: "flex" }}
                                    >
                                        <Grid container justifyContent="center" alignItems="center">
                                            <Grid item>
                                                <MDTypography variant={"button"}>Data fine lavori Stimata:<span style={{ marginLeft: 5 }} /> </MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}>{" "}{dataStimata}</MDTypography>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                            <Grid item>
                                                <MDTypography variant={"button"} fontWeight={"bold"}>{scostamento} </MDTypography>
                                            </Grid>
                                            <Grid item>
                                                <MDTypography variant={"button"}>{""} <span style={{ marginLeft: 5 }} />Giorni di SCOSTAMENTO</MDTypography>
                                            </Grid>
                                        </Grid>


                                    </Grid>

                                </Grid>
                            </Grid>

                            {/*data fine lavori*/}
                            <Grid item sm={4}>
</Grid>
                        <Grid item sm={4}>

                            </Grid>
                            {/*fine lavori*/}



                            <Grid item sm={2} ml={"auto"}>

                                <MDButton variant="text" color="info" onClick={() => { this.props.openCommessa() }}>vai al cantiere {">"}</MDButton>
                                <MDButton variant="text" color="info" onClick={() => { this.props.openDetail() }}>dettagli {">"}</MDButton>
                            </Grid>
                        </Grid>


                    </MDBox>
                </Grid>
            </Grid>

        )

    }
}

export default CartaContabilita;


CartaContabilita.defaultProps = {

}
